module.exports = __webpack_public_path__ + "Roboto-Medium.fc78759e93a6cac50458.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Medium.woff
// module id = ../../../../../src/font/roboto/Roboto-Medium.woff
// module chunks = 1